import type { FaseOS } from '../types';

export type NavApp = 'google' | 'waze';

/** Destino preferindo coords salvas; senão texto do endereço. */
export function getFaseDestination(fase: FaseOS): {
  lat?: number;
  lng?: number;
  address?: string;
} | null {
  const lat =
    fase.destino_lat != null ? Number(fase.destino_lat) : NaN;
  const lng =
    fase.destino_lng != null ? Number(fase.destino_lng) : NaN;
  const hasCoords = !Number.isNaN(lat) && !Number.isNaN(lng);
  const address = fase.endereco_destino?.trim();

  if (hasCoords) {
    return { lat, lng, address: address || undefined };
  }
  if (address) {
    return { address };
  }
  return null;
}

export function buildNavigationUrl(
  app: NavApp,
  dest: { lat?: number; lng?: number; address?: string }
): string {
  const hasCoords =
    dest.lat != null &&
    dest.lng != null &&
    !Number.isNaN(dest.lat) &&
    !Number.isNaN(dest.lng);

  if (app === 'google') {
    if (hasCoords) {
      return `https://www.google.com/maps/dir/?api=1&destination=${dest.lat},${dest.lng}&travelmode=driving`;
    }
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
      dest.address || ''
    )}&travelmode=driving`;
  }

  // Waze
  if (hasCoords) {
    return `https://waze.com/ul?ll=${dest.lat},${dest.lng}&navigate=yes`;
  }
  return `https://waze.com/ul?q=${encodeURIComponent(
    dest.address || ''
  )}&navigate=yes`;
}

/** Abre Maps/Waze fora do app (custo zero). */
export function openExternalNavigation(
  app: NavApp,
  fase: FaseOS
): { ok: true } | { ok: false; error: string } {
  const dest = getFaseDestination(fase);
  if (!dest) {
    return {
      ok: false,
      error: 'Esta fase não tem endereço ou coordenadas de destino.',
    };
  }

  const url = buildNavigationUrl(app, dest);
  window.open(url, '_blank');
  return { ok: true };
}
